/** Open the single costs page while preserving the industrialization filters. */
export function industrializationCostsLocation(code = '', query = {}, hash = '') {
    return {
        name: 'CostiArticolo',
        params: { codice: code || undefined },
        query: { ...query, from: 'industrializzazione' },
        hash,
    };
}

export function industrializationReturnLocation(query = {}) {
    const filters = { ...query };
    delete filters.from;
    delete filters.alt;
    return { name: 'attrezzature-industrializzazione', params: { view: filters.catalog === 'new' ? 'nuovi' : 'candidati' }, query: filters };
}
